import type { CourseAssetListResponseContentItem } from './courseAssetListResponseContentItem';
import type { CourseAssetListResponsePageable } from './courseAssetListResponsePageable';

/**
 * 강의 자료 목록 응답
 */
export interface CourseAssetListResponse {
  /** 강의 자료 목록 */
  content?: CourseAssetListResponseContentItem[];
  /** 빈 페이지 여부 */
  empty?: boolean;
  /** 첫 번째 페이지 여부 */
  first?: boolean;
  /** 마지막 페이지 여부 */
  last?: boolean;
  /** 현재 페이지 번호 (0부터 시작) */
  number?: number;
  /** 현재 페이지의 요소 수 */
  numberOfElements?: number;
  /** Spring Data Pageable 정보 */
  pageable?: CourseAssetListResponsePageable;
  /** 페이지 크기 */
  size?: number;
  /** 전체 자료 수 */
  totalElements?: number;
  /** 전체 페이지 수 */
  totalPages?: number;
}
